import { createAsyncThunk, Dispatch } from "@reduxjs/toolkit";
import { EventAccommodationRoomService } from "Bands/services/EventAccommodationRoomService";

import { BAND_ACTIONS } from "Bands/types";

export const dispatchGetEventAccommodationRoomsForBlock = (dispatch: Dispatch<any>, id: string) => {
  return dispatch(getEventAccommodationRoomsForBlock({ id }));
};

export const getEventAccommodationRoomsForBlock = createAsyncThunk(
  BAND_ACTIONS.getEventAccommodationRoomsForBlock,
  async ({ id }: { id: string }, { rejectWithValue }) => {
    try {
      const rooms = await EventAccommodationRoomService.getEventAccommodationRoomsForBlock(id);

      return rooms;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
